import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../../utils/ReactUtils'
import ImageStatic from '../../ImageStatic'
import Link from '../../Link'

import styles from './styles'


const decorators = [
  memoized,
]

function SocialLink(props) {
  const { icon, href, target, label } = props

  return (
    <Link
      target={target}
      rel="noopener noreferrer"
      link={href}
      style={{ textDecoration: 'none' }}
    >
      {label && <p className="socialLabel">{label}</p>}
      {icon
      && <ImageStatic src={`/images/icons/${icon}.svg`} />
    }
      <style jsx>{styles}</style>
    </Link>
  )
}

SocialLink.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  href: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
}

SocialLink.defaultProps = {
  icon: '',
  label: '',
}

SocialLink = chainDecorators(decorators, SocialLink)

export default SocialLink
